module.exports = __webpack_public_path__ + "static/img/redGoods@2x.1f20ce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/redGoods@2x.png
// module id = RPM8
// module chunks = 1